import { __decorate, __extends } from "tslib";
import { FilterUtils, PROPS_LIST, proxyTo, serialisable } from '../utils/FilterUtils';
import { BlurFilter } from './BlurFilter';
import { DropShadowTask } from './tasks/webgl/DropShadowTask';
var DropShadowFilter = /** @class */ (function (_super) {
    __extends(DropShadowFilter, _super);
    function DropShadowFilter(options) {
        var _this = _super.call(this, options) || this;
        _this._shadowTask = new DropShadowTask();
        _this.distance = 0;
        _this.angle = 0;
        _this.color = 0x0;
        _this.alpha = 1;
        _this.strength = 1;
        _this.inner = false;
        _this.knockout = false;
        _this.hideObject = false;
        _this.addTask(_this._shadowTask);
        _this.applyProps(options);
        return _this;
    }
    DropShadowFilter.prototype.applyProps = function (model) {
        if (!model)
            return;
        // run all model field that changed
        for (var _i = 0, _a = this[PROPS_LIST]; _i < _a.length; _i++) {
            var key = _a[_i];
            if (key in model) {
                this[key] = model[key];
            }
        }
        if (model.filterName === DropShadowFilter.filterNameAlt) {
            this.angle = 0;
            this.distance = 0;
        }
    };
    DropShadowFilter.prototype.meashurePad = function (input, target) {
        if (target === void 0) { target = input; }
        var pad = FilterUtils.meashureBlurPad(this.blurX, this.blurY, 3, false);
        target.copyFrom(input);
        // for outer or both need render a drop shadow with valid pad
        var dist = this.distance;
        if (!this.inner && dist > 0) {
            var rad = this.angle * Math.PI / 180;
            pad.x += Math.sin(rad) * dist * 2;
            pad.y += Math.sin(rad) * dist * 2;
        }
        target.x -= pad.x;
        target.y -= pad.y;
        target.width += pad.x;
        target.height += pad.y;
        return target;
    };
    DropShadowFilter.prototype.setRenderState = function (source, target, sourceRect, outRect, filterManager) {
        _super.prototype.setRenderState.call(this, source, target, sourceRect, outRect, filterManager);
        var subtarget = this._hBlurTask.target;
        var secondPass = filterManager.popTemp(subtarget.width, subtarget.height);
        // emit real
        // crop a dest rectangle
        // override blur target
        // we use a copyFrom, because if we will use referece - we can corrupt instance
        this._shadowTask.inputRect.copyFrom(this._vBlurTask.inputRect);
        this._shadowTask.destRect.copyFrom(outRect);
        //reset output size
        this._vBlurTask.inputRect.setTo(0, 0, 0, 0);
        this._vBlurTask.destRect.setTo(0, 0, 0, 0);
        // and reset target
        this._vBlurTask.target = secondPass;
        this._shadowTask.source = secondPass;
        this._shadowTask.sourceImage = source;
        this._shadowTask.target = target;
        this._temp.push(secondPass);
    };
    DropShadowFilter.filterName = 'dropShadow';
    DropShadowFilter.filterNameAlt = 'glow';
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "distance", void 0);
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "angle", void 0);
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "color", void 0);
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "alpha", void 0);
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "strength", void 0);
    __decorate([
        serialisable
    ], DropShadowFilter.prototype, "quality", void 0);
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "inner", void 0);
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "knockout", void 0);
    __decorate([
        serialisable,
        proxyTo('_shadowTask')
    ], DropShadowFilter.prototype, "hideObject", void 0);
    return DropShadowFilter;
}(BlurFilter));
export { DropShadowFilter };
